import React, { ReactElement } from 'react';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';

import ServiceEntityList from '../ServiceEditor/other/ServiceEntityList';
import { TId } from 'types';

/**
 *
 */
class ServiceItems<T extends TId> extends ServiceEntityList<T> {
  /**/
  renderItem = (item: T): ReactElement => (
    <Col key={item.id} span={24 / this.state.colCount}>
      {React.cloneElement(this.props.children, { item: item })}
    </Col>
  );

  /**/
  renderContent(): ReactElement {
    const { data, gutter } = this.props;
    const { colCount, isExpanded } = this.state;
    const firstChunk = data.slice(0, colCount);
    const restChunk =
      isExpanded || !this.shouldShowButton() ? data.slice(colCount) : [];

    return (
      <Row gutter={gutter}>
        {firstChunk.map(this.renderItem)}
        {restChunk.map(this.renderItem)}
      </Row>
    );
  }
}

/**/
export default ServiceItems;
